// extracted by mini-css-extract-plugin
export default {"grid":"methodMapping_grid__FR6pN"};